import Vue from "vue";
import Router from "vue-router";
import commonRouter from "./modules/common"; // 公共路由
import shoppingRouter from "./modules/shopping"; // 首页路由
import loginRouter from "./modules/login"; // 登录路由
import crypto from "../utils/crypto";
Vue.use(Router);

function deepCopy(obj) {
  if (obj instanceof Object) {
    const newObj = {};
    if (Array.isArray(obj)) {
      const arr = [];
      obj.forEach(item => {
        arr.push(deepCopy(item));
      });
      return arr;
    } else {
      for (const key in obj) {
        const value = obj[key];
        if (typeof value === "function") {
          newObj[key] = value.bind(newObj);
        } else if (typeof value === "object") {
          if (Array.isArray(value)) {
            newObj[key] = [];
            value.forEach(item => {
              newObj[key].push(deepCopy(item));
            });
          } else {
            newObj[key] = deepCopy(value);
          }
        } else {
          newObj[key] = value;
        }
      }
    }
    return newObj;
  } else {
    return obj;
  }
}

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  // 解决空对象中含有{__ob__: Observer}，深拷贝
  let newLocation = deepCopy(location);
  // let newLocation = location
  if (newLocation?.query && Object.keys(newLocation.query).length !== 0) {
    newLocation = location.query?.__params
      ? location
      : {
          ...location,
          query: {
            __params: crypto.Encrypt(JSON.stringify(newLocation.query))
          }
        };
  }
  return originalPush.call(this, newLocation);
};

const originalRoe = Router.prototype.resolve;
Router.prototype.resolve = function resolve(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalRoe.call(this, location, onResolve, onReject);
  // 解决空对象中含有{__ob__: Observer}，深拷贝
  let newLocation = deepCopy(location);
  // let newLocation = location
  if (newLocation?.query && Object.keys(newLocation.query).length !== 0) {
    newLocation = location.query?.__params
      ? location
      : {
          ...location,
          query: {
            __params: crypto.Encrypt(JSON.stringify(newLocation.query))
          }
        };
  }
  return originalRoe.call(this, newLocation);
};

export const constantRouterMap = [
  ...commonRouter,
  ...shoppingRouter,
  ...loginRouter,
  {
    path:
      "/eGK7KbU4gs8xA4Uy-4NH42ten01820HFBXB5XoHwkUVKTsgfWTz6FmpkR0gO9ESR8wd-&eaid-b32aa700081C4C00000564C26251",
    component: () => import("@/app/shop/views/list.vue"),
    name: "list"
  }
];

export default new Router({
  mode: "history", // require service support
  // 浏览器回退,切换路由时默认滚动的位置
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});
